import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=4c6795dc&scoped=true"
import script from "./Tooltip.vue?vue&type=script&lang=ts"
export * from "./Tooltip.vue?vue&type=script&lang=ts"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=4c6795dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6795dc",
  null
  
)

export default component.exports